<template>
  <div style="position:relative">
    <search-form @setSearchCondition="setSearchCondition" @clearSearch="clearSearch"></search-form>
    <!--      操作按钮-->
    <div class="table-operator" style="position:absolute;top:40px;left:0">
      <a-button type="primary" @click="handleAdd" v-action:add><a-icon type="plus" />新增</a-button>
      <!-- <a-button @click="exportFile" v-action:export><a-icon type="export" />导出</a-button> -->
    </div>
    <!--表格-->
    <zm-table
      :columns="table.columns"
      :rowKey="record => record.id"
      :dataSource="table.data"
      :pagination="pagination"
      :loading="table.loading"
      @change="handleTableChange"
      style="margin-top:10px"
      :scroll="{x:1100}"
    >
      <template v-slot:actions="{ text, record }">
        <div class="actionGroup">
          <div>
            <a href="javascript:;" @click="() => handleView(record)">查看</a>
          </div>
          <template v-if="record.status === 1">
            <template v-if="record.jobStatus !== 1 && $auth('baseInfo.change')">
              <a-divider type="vertical" />
              <a href="javascript:;" @click="() => handleChange(record)">转正</a>
            </template>
            <template v-if="$auth('baseInfo.leave')">
              <a-divider type="vertical" />
              <a href="javascript:;" @click="() => handleLeave(record)">离职</a>
            </template>
            <template v-if="$auth('baseInfo.update')">
              <a-divider type="vertical" />
              <a href="javascript:;" @click="() => handleEdit(record)">编辑</a>
            </template>
          </template>
          
          <div v-if="record.status === 9 && $auth('baseInfo.delete_user')">
            <a-divider type="vertical" />
            <a-popconfirm
              :title="'你确定要删除人员“' + record.userName + '”吗?'"
              @confirm="handleDelete(record.id)"
            >
              <a class="delete" href="javascript:;">删除</a>
            </a-popconfirm>
          </div>
        </div>
      </template>
    </zm-table>
    <!--查看弹出组件-->
    <edit-modal ref="editModal" @refreshTable="initTableData"></edit-modal>
    <view-modal ref="viewModal"></view-modal>
    <leave-modal ref="leaveModal" @refreshTable="initTableData"></leave-modal>
    <job-status-modal ref="jobStatusModal" @refreshTable="initTableData"></job-status-modal>
    <export-modal ref="exportModal"></export-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  getUserBaseInfo,
  updateUserStatus,
  deleteUser
} from '@/api/baseInfo'

import editModal from './editModal'
import searchForm from './searchForm'
import exportModal from './exportModal'
import baseCard from '@/CrComponents/Card/Card'
import ViewModal from './viewModal.vue'
import LeaveModal from './leaveModal.vue'
import JobStatusModal from './jobStatusModal.vue'

export default {
  name: 'QualityList',
  components: {
    editModal,
    searchForm,
    exportModal,
    baseCard,
    ViewModal,
    LeaveModal,
    JobStatusModal
  },
  computed: mapGetters(['selectedDept']),
  watch: {
    selectedDept () {
      if (this.selectedDept.id) {
        this.deptId = this.selectedDept.id
        this.initTableData()
      } else {
        this.deptId = null
      }
    }
  },
  data () {
    return {
      // card相关属性设置
      cardOption: {},
      // 搜索form中的参数
      searchFormModel: {
        status: 1
      },
      // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      searchModel: {},
      selectedRows: [],
      deptId: null,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      table: {
        data: [],
        columns: [
          {
            title: '姓名',
            width: 80,
            align: 'center',
            dataIndex: 'userName'
          },
          {
            title: '职工编号',
            width: 90,
            align: 'center',
            dataIndex: 'userNumber'
          },
          // {
          //   title: '人员分组',
          //   width: 140,
          //   align: 'center',
          //   dataIndex: 'groupNames'
          // },
          {
            title: '角色',
            align: 'center',
            dataIndex: 'roleNames'
          },
          {
            title: '组织机构',
            width: 140,
            align: 'center',
            dataIndex: 'deptName'
          },
          {
            title: '职称',
            width: 120,
            align: 'center',
            dataIndex: 'rankName'
          },
          {
            title: '人员状态',
            width: 140,
            align: 'center',
            dataIndex: 'status',
            customRender: text => {
              var statusName
              switch (text) {
                case 0:
                  statusName = '待审核'
                  break
                case 1:
                  statusName = '正常'
                  break
                case 4:
                  statusName = '冻结'
                  break
                case 9:
                  statusName = '离职'
                  break
                default:
                  break
              }
              return statusName
            }
          },
          {
            title: '操作',
            width: 200,
            fixed: 'right',
            align: 'right',
            scopedSlots: {
              customRender: 'actions'
            }
          }
        ],
        searchCondition: {},
        loading: false
      }
    }
  },
  mounted () {
    this.searchModel = { ...this.pagination, ...this.searchFormModel }
    // this.initTableData()
    // this.initDictData()
  },
  methods: {
    // 搜索
    setSearchCondition (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.searchModel = { ...this.pagination, ...searchFormModel }
      this.initTableData()
    },
    // 重置
    clearSearch (searchFormModel) {
      // this.deptId = null
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchFormModel = searchFormModel
      this.searchModel = { ...this.pagination, ...searchFormModel }
      this.initTableData()
    },
    // 初始化表格数据
    initTableData () {
      this.table.loading = true

      if (this.deptId) {
        this.searchModel.deptId = this.deptId
      }

      console.log('this.deptId', this.deptId)
      getUserBaseInfo(this.searchModel).then(res => {
        if (res.status === 0) {
          this.table.loading = false
          this.table.data = res.data.list
          this.pagination.total = res.data.total
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      this.searchModel = {
        ...this.searchFormModel,
        ...this.pagination
      }
      this.initTableData()
    },
    // 新增人员
    handleAdd () {
      const model = { deptId: this.deptId }
      this.$refs.editModal.setTitle('新增人员信息')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_ADD)
      this.$refs.editModal.setModel(model)
      this.$refs.editModal.open(true)
    },
    // 查看详情
    handleView (model) {
      this.$refs.viewModal.setTitle('查看人员信息')
      this.$refs.viewModal.setType(this.$sysInfo.MODAL_VIEW)
      this.$refs.viewModal.setModel(model)
      this.$refs.viewModal.open(true)
    },
    // 信息编辑
    handleEdit (model) {
      this.$refs.editModal.setTitle('编辑人员信息')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.editModal.setModel(model)
      this.$refs.editModal.open(true)
    },
    // 转正
    handleChange (model) {
      this.$refs.jobStatusModal.setTitle('人员转正')
      this.$refs.jobStatusModal.setModel(model)
      this.$refs.jobStatusModal.open(true)
    },
    // 离职
    handleLeave (model) {
      this.$refs.leaveModal.setTitle('人员离职')
      this.$refs.leaveModal.setModel(model)
      this.$refs.leaveModal.open(true)
    },
    // 改变人员状态
    handleUpdateUserStatus (userId, status) {
      // let query = {
      //   id: userId,
      //   status: status
      // }

      // updateUserStatus(query).then(res => {
      //   if (res.status === 0) {
      //     this.$message.success(res.info.message)
      //     this.initTableData()
      //   } else {
      //     this.$message.error(res.info.message)
      //   }
      // })
      console.log('userId', userId)
      updateUserStatus(userId, status).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 改变人员状态
    handleDelete (userId) {
      const query = {
        id: userId
      }

      deleteUser(query).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 导出资质文件
    exportFile () {
      this.$refs.exportModal.open(true)
    }
  }
}
</script>

<style lang="less">
.ant-layout-content .ant-layout .content {
    height: 100%;
    // height: calc(100vh - 150px);
    overflow-y: auto;
    overflow-x: hidden;
}
.public-modal {
  .row-title {
    font-size: 16px;
    font-weight: bold;
    margin-left: 20px;
  }

  .add-btn {
    width: 87%;
    margin-left: 5%;
  }

  .date-picker {
    width: 227px;
  }

  .delete-btn {
    margin-top: 3px;
  }
}

.actionGroup {
  div {
    display: inline-block;
  }
}
</style>
